import React, { useEffect, useState } from "react";
import { Stack, popoverClasses } from "@mui/material";
import _ from "lodash";
import Topbar from "../navigation/topBar";
import "../index.css";
import { useSelector, useDispatch } from "react-redux";
import { DatePicker } from "antd";
import AnnotatorSidebar from "./annotatorSidebar";
import LinearProgress from "@mui/material/LinearProgress";
import { ShelfViewSnackbar } from "./components/snackbar";
import "./annotator.css";
import ThumbnailViewer from "./thumbnailViewer";

//console.log(data,"data")
import ConflictsThumbnailViewer from "./conflicts/ConflictsThumbnailViewer";
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardDoubleArrowLeftIcon from "@mui/icons-material/KeyboardDoubleArrowLeft";
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import KeyboardDoubleArrowRightIcon from "@mui/icons-material/KeyboardDoubleArrowRight";
import { fetchRange } from "../store/ShelfView/conflictThumbnail";
import { fetchRangeThumbnailStore } from "../store/ShelfView/ThumbnailStore";
import ArrowCircleRightIcon from '@mui/icons-material/ArrowCircleRight';
import ArrowCircleLeftIcon from '@mui/icons-material/ArrowCircleLeft';

const { RangePicker } = DatePicker;

const ShelfView = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchRange());
    dispatch(fetchRangeThumbnailStore())
  }, []);
  

  const { loading } = useSelector((state) => state.shelfViewFeedbackStore);
  const { sd, ed, type, dataType, selectedType, hierarchyData } = useSelector(
    (state) => state.thumbnailStore
  );
  const { user, username, userId } = useSelector((state) => state.userStore);
  const { cursorDetails } = useSelector((state) => state.thumbnailStore);
  const { curPage } = useSelector((state) => state.conflictsPageStore);
  useEffect(() => {}, [curPage]);
  const pages = [
    {
      name: "default",
      page: <ThumbnailViewer />,
    },
    {
      name: "conflicts",
      page: <ConflictsThumbnailViewer />,
    },
  ];
  const selectedPage = pages.filter((page) => curPage === page.name)[0]["page"];
  const [toggleSidebar, setToggleSidebar] = useState(true);
  const [hoverSidebar, setHoverSidebar] = useState(false);

  const toggleSidebarFunc = () => {
    setToggleSidebar((prev) => !prev);
  };
  const handleMouse = () => {
    setHoverSidebar((prev) => !prev);
  };
  // console.log(hoverSidebar);
  return (
    <Stack sx={{ backgroundColor: "rgba(255, 255, 255)", minHeight: "100vh",width:"100%" }}>
      <Stack>
        <Topbar
          logo="Constems-AI"
          title={"Annotator"}
          user={sessionStorage.getItem("user")}
          user_icon={true}
        />
        {loading && <LinearProgress />}
      </Stack>
      <Stack
        direction="row"
        sx={{ width: "100%", height: "calc(100vh - 4rem)", marginTop: "4rem" }}
        // className="css-1sazv7p-MuiStack-root"
      >
        <Stack
          direction="column"
          spacing={2}
          sx={{
            width: "fit-content",
            margin: "0.75rem",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <div
            style={{
              width: "100%",
              position: "relative",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            {toggleSidebar && <AnnotatorSidebar />}
            {/* {toggleSidebar ? (
              hoverSidebar ? (
                <KeyboardDoubleArrowLeftIcon
                  onMouseLeave={handleMouse}
                  onClick={toggleSidebarFunc}
                  style={{ cursor: "pointer", color: "rgba(73 , 148, 236, 0.875)" }}
                />
              ) : (
                <KeyboardArrowLeftIcon
                  onMouseEnter={handleMouse}
                  style={{ cursor: "pointer" , color: "rgba(73 , 148, 236, 0.875)"}}
                />
              )
            ) : hoverSidebar ? (
              <KeyboardArrowRightIcon
              onMouseEnter={handleMouse}
               
                style={{ cursor: "pointer" , color: "rgba(73 , 148, 236, 0.875)"}}
              />
            ) : (
              <KeyboardDoubleArrowRightIcon
              onClick={toggleSidebarFunc}
                onMouseLeave={handleMouse}
                style={{ cursor: "pointer", color: "rgba(73 , 148, 236, 0.875)" }}
              />
            )} */}
             {toggleSidebar? (
          hoverSidebar ? (
            <ArrowCircleLeftIcon
              onMouseLeave={handleMouse}
              onClick={toggleSidebarFunc}
              style={{ cursor: "pointer", color: "rgba(73 , 148, 236, 0.875)" }}
            />
          ) : (
            <KeyboardDoubleArrowLeftIcon
              onMouseEnter={handleMouse}
              style={{ cursor: "pointer", color: "rgba(73 , 148, 236, 0.875)" }}
            />
          )
        ) : hoverSidebar ? (
          < KeyboardDoubleArrowRightIcon
            onMouseEnter={handleMouse}
            style={{ cursor: "pointer", color: "rgba(73 , 148, 236, 0.875)" }}
          />
        ) : (
          < ArrowCircleRightIcon
            onClick={toggleSidebarFunc}
            onMouseLeave={handleMouse}
            style={{ cursor: "pointer", color: "rgba(73 , 148, 236, 0.875)" }}
          />
        )}
          </div>
        </Stack>
        {selectedPage}
        {/* <ThumbnailViewer /> */}
        
        <ShelfViewSnackbar />
      </Stack>
    </Stack>
  );
};

export default ShelfView;
